if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if (this.form) {
				const enableVariantInput = () => {
					const variantInput = this.form.querySelector('[name=id]');
					if (variantInput) variantInput.disabled = false;
				};
				if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enableVariantInput, { once: true });
				else enableVariantInput();
				this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
			} else {
				console.warn('Form with ID #product-form not found.')
			}

      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      //this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;
      if(this.closest('[data-art-product],[data-legacy-product]') && (!window.MPGelato?.isPoster(formData.get('id')) || typeof window.MPGelato?.posterItems !== 'function')){
        this.handleErrorMessage(window.MPGelatoConfig?.routingError || window.MPGelatoConfig?.error || this.closest('[data-art-product],[data-legacy-product]').querySelector('mp-art-variant-picker')?.dataset.error);
        this.submitButton.removeAttribute('aria-disabled');this.submitButton.classList.remove('loading');return;
      }
      if(window.MPGelato?.isPoster(formData.get('id'))){
        const quantity=Math.max(1,Number(formData.get('quantity')||1)),properties={};
        for(const [key,value] of formData.entries()){const match=key.match(/^properties\[(.+)\]$/);if(match&&typeof value==='string')properties[match[1]]=value;}
        let items;
        try {
          if(typeof window.MPGelato.posterItems === 'function') items=window.MPGelato.posterItems(Number(formData.get('id')),quantity,properties);
          else {
            const group=crypto.randomUUID();
            items=[{id:Number(formData.get('id')),quantity,properties:{...properties,_mp_group:group,_mp_role:'poster',_mp_route:window.MPGelato.enabled?'gelato':'local-poster'}},window.MPGelato.tagItem(group,quantity)];
          }
        }
        catch(error) {
          this.handleErrorMessage(error.message || window.MPGelatoConfig?.routingError || window.MPGelatoConfig?.error);
          this.submitButton.removeAttribute('aria-disabled');this.submitButton.classList.remove('loading');return;
        }
        const body={items};
        if(this.cart){body.sections=this.cart.getSectionsToRender().map(section=>section.id);body.sections_url=window.location.pathname;}
        config.headers['Content-Type']='application/json';config.body=JSON.stringify(body);
      }

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if(response.items?.length)response={...response,id:response.items[0].id};
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          //this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
